import React, { FunctionComponent, useContext } from 'react';
import useInvestorMe from 'hooks/use-investor-me';
import WizardContext from 'libraries/wizard/wizard-context';
import LoadingRing from 'ui/atoms/loading-ring';
import Translate from 'ui/atoms/translate';
import TaxInformationForm, { TaxInformationFields } from './tax-information-form';
import { AnyServerError } from 'hooks/use-api-error';
import WizardHeader from 'libraries/wizard/wizard-header';
import Header from 'ui/atoms/header';

const TaxInformationStep: FunctionComponent<{
  onSubmit: (values: TaxInformationFields) => void;
  showLoading: boolean;
  error?: AnyServerError;
}> = ({ onSubmit, showLoading, error }) => {
  const { loading, finalize, isRegisterOnlyFlow } = useContext(WizardContext);
  const { investor: me, error: meError } = useInvestorMe();

  const onSubmitValues = async (values: TaxInformationFields) => {
    await onSubmit(values);
    finalize();
  };

  if (meError) return null;

  if (showLoading) return <LoadingRing />;

  return (
    <>
      <WizardHeader />
      <Header size="large" spacing="xlarge">
        <Translate name="taxInformation.title" />
      </Header>
      <TaxInformationForm
        onSubmit={onSubmitValues}
        currentTaxInformation={me?.person.taxInformation}
        isRegisterOnlyFlow={isRegisterOnlyFlow}
        loading={showLoading || loading}
        error={error || meError}
      />
    </>
  );
};

export default TaxInformationStep;
